import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Divider from '@material-ui/core/Divider';

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

export default function CustomizedAccordions(props) {
  const entreeItems = props.menu;

  const sideItems = props.sides;
  const drinkItems = props.drinks;

  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <div style={{ display: 'flex' }}>
        <Accordion
          //square
          // expanded={expanded === "panel1"}
          style={{ width: '100vw' }}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            aria-controls="panel1d-content"
            id="panel1d-header"
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography>Entrees</Typography>
          </AccordionSummary>

          <AccordionDetails style={{ display: 'inline grid' }}>
            <div>
              {entreeItems.length === 0
                ? 'loading...'
                : entreeItems.map((item) => (
                    <div>
                      <Typography
                        variant="h6"
                        style={{ fontSize: '1.00rem', fontWeight: 'bold' }}
                      >
                        {item.item}
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{
                          fontWeight: 500,
                          fontSize: '14px',
                          fontFamily:
                            'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
                        }}
                      >
                        ${item.price}
                      </Typography>
                      <Typography
                        variant="body2"
                        style={{
                          marginBottom: 20,
                          color: 'rgb(118, 118, 118)',
                          fontSize: '14px',
                          fontWeight: '500',
                          lineHeight: '20px',
                          fontFamily:
                            'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
                        }}
                      >
                        {item.description}
                      </Typography>
                      <Divider />
                    </div>
                  ))}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
      <div style={{ display: 'flex' }}>
        <Accordion style={{ width: '100vw' }} onChange={handleChange('panel2')}>
          <AccordionSummary
            aria-controls="panel1d-content"
            id="panel1d-header"
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography>Sides</Typography>
          </AccordionSummary>

          <AccordionDetails style={{ display: 'inline grid' }}>
            <div>
              {sideItems.length === 0
                ? 'loading...'
                : sideItems.map((item) => (
                    <div>
                      <Typography
                        variant="h6"
                        style={{ fontSize: '1.00rem', fontWeight: 'bold' }}
                      >
                        {item.item}
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{
                          fontWeight: 500,
                          fontSize: '14px',
                          fontFamily:
                            'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
                        }}
                      >
                        ${item.price}
                      </Typography>
                      <Typography
                        variant="body2"
                        style={{
                          marginBottom: 20,
                          color: 'rgb(118, 118, 118)',
                          fontSize: '14px',
                          fontWeight: '500',
                          lineHeight: '20px',
                          fontFamily:
                            'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
                        }}
                      >
                        {item.description}
                      </Typography>
                      <Divider />
                    </div>
                  ))}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>

      <div style={{ display: 'flex' }}>
        <Accordion style={{ width: '100vw' }} onChange={handleChange('panel3')}>
          <AccordionSummary
            aria-controls="panel1d-content"
            id="panel1d-header"
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography>Drinks</Typography>
          </AccordionSummary>

          <AccordionDetails style={{ display: 'inline grid' }}>
            <div>
              {drinkItems.length === 0
                ? 'loading...'
                : drinkItems.map((item) => (
                    <div>
                      <Typography
                        variant="h6"
                        style={{ fontSize: '1.00rem', fontWeight: 'bolder' }}
                      >
                        {item.item}
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{
                          fontWeight: 500,
                          fontSize: '14px',
                          fontFamily:
                            'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
                        }}
                      >
                        ${item.price}
                      </Typography>
                      <Typography
                        variant="body2"
                        style={{
                          marginBottom: 20,
                          color: 'rgb(118, 118, 118)',
                          fontSize: '14px',
                          fontWeight: '500',
                          lineHeight: '20px',
                          fontFamily:
                            'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
                        }}
                      >
                        {item.description}
                      </Typography>
                      <Divider />
                    </div>
                  ))}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}
